import React from 'react';
import { IConnectedPage } from '../../../../../types/api/connectedPages/IConnectedPage';
import { defaultDimensions } from '../DefaultDimensions';
import LeafNode from './LeafNode';
import { getCharacterCount, getChildPagesCoordinates, getCurrentWidth } from '../utils/ConnectedPagesHelperFunctions';
import { getHexColor } from '../../../../../types/ICategory';
import handleCopy from '../utils/handleCopy';
import { IDimensions } from '../interfaces/IConnectedPagesGraphProperties';

type ConnectedPagesGraphChildPagesProps = {
  containerDimensions: { width: number; height: number };
  ariaLabel: string;
  ariaLabelPrefix: string;
  childPages: IConnectedPage[];
  radiusToPositionOn: number;
  maxPagesToRender: number;
  onClickHandler?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string) => void;
  dimensions?: IDimensions;
};

export function ConnectedPagesGraphChildPages({
  containerDimensions,
  ariaLabel,
  ariaLabelPrefix,
  childPages,
  radiusToPositionOn,
  maxPagesToRender,
  dimensions = defaultDimensions,
  onClickHandler,
}: ConnectedPagesGraphChildPagesProps) {
  return (
    <ul aria-label={ariaLabel} className="connected-pages-graph__list">
      {childPages.map((node, index) => (
        <LeafNode
          key={node.pageLink.url}
          node={node}
          maxMinDimensions={dimensions.childPage}
          coordinates={getChildPagesCoordinates(containerDimensions, index, maxPagesToRender, radiusToPositionOn)}
          borderColorFromCategories={getHexColor(node.categories)}
          width={getCurrentWidth(containerDimensions.width, dimensions.childPage)}
          maxNumberOfCharactersBeforeEllipse={getCharacterCount(containerDimensions.width, dimensions.childPage)}
          ariaLabelPrefix={ariaLabelPrefix}
          // Events
          onCopy={handleCopy}
          onClick={onClickHandler}
        />
      ))}
    </ul>
  );
}
